import { Controller } from "react-hook-form";
import { Label } from "@/modern/components/ui/label";
import { Checkbox } from "@/modern/components/ui/checkbox";
import { ViewEditorSection } from "../components/ViewEditorSection";
import { useViewEditor } from "../context/ViewEditorContext";

export const ShareView = () => {
  const { isShareable, form } = useViewEditor();

  return (
    <ViewEditorSection
      title="Sharing Settings"
      subtitle="Control who can access this view"
    >
      <div className="space-y-3">
        <div className="flex items-start space-x-3">
          <Controller
            control={form.control}
            name="isShareToHQ"
            render={({ field }) => (
              <>
                <Checkbox
                  id="shareToHq"
                  checked={field.value}
                  onCheckedChange={field.onChange}
                  disabled={isShareable}
                  className="mt-0.5"
                />
                <div className="space-y-1 leading-none">
                  <Label htmlFor="shareToHq" className="text-sm font-normal cursor-pointer text-foreground">
                    Share To HQ
                  </Label>
                </div>
              </>
            )}
          />
        </div>

        <div className="flex items-start space-x-3">
          <Controller
            control={form.control}
            name="isShareToWorkforce"
            render={({ field }) => (
              <>
                <Checkbox
                  id="shareToWorkforce"
                  checked={field.value}
                  onCheckedChange={field.onChange}
                  disabled={isShareable}
                  className="mt-0.5"
                />
                <div className="space-y-1 leading-none">
                  <Label htmlFor="shareToWorkforce" className="text-sm font-normal cursor-pointer text-foreground">
                    Share To Workforce
                  </Label>
                </div>
              </>
            )}
          />
        </div>

        <div className="flex items-start space-x-3">
          <Controller
            control={form.control}
            name="isShareToPublic"
            render={({ field }) => (
              <>
                <Checkbox
                  id="shareToPublic"
                  checked={field.value}
                  onCheckedChange={field.onChange}
                  disabled={isShareable}
                  className="mt-0.5"
                />
                <div className="space-y-1 leading-none">
                  <Label htmlFor="shareToPublic" className="text-sm font-normal cursor-pointer text-foreground">
                    Share To Public
                  </Label>
                </div>
              </>
            )}
          />
        </div>
      </div>
    </ViewEditorSection>
  );
};
